<div class="projects-page">
  <div class="projects-header">
    <div>
      <h1>Projects</h1>
      <p>Trade projects your company is participating in.</p>
    </div>
    @if (canCreateProject) {
      <button mat-flat-button class="btn-submit" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        New project
      </button>
    }
  </div>

  <div class="table-toolbar">
    <div class="count-card count-card--blue">
      <div class="count-card__icon"><span class="material-icons">folder</span></div>
      <div class="count-card__text">
        <span class="count-card__main"><strong>{{ filteredProjects.length }}</strong> Projects</span>
        <span class="count-card__status">{{ statusFilterLabel }}</span>
      </div>
    </div>

    <app-filter-select
      [(ngModel)]="statusFilter"
      name="statusFilter"
      [options]="statusOptions"
      allLabel="All statuses"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (filteredProjects.length === 0) {
    <app-empty-state message="No projects match this filter." />
  } @else {
    <div class="project-grid">
      @for (project of filteredProjects; track project.id) {
        <a [routerLink]="['/projects', project.id]" class="project-card">
          <div class="project-card__top">
            <span class="project-code">{{ project.code }}</span>
            <app-status-badge [status]="project.status" />
          </div>
          <strong class="project-name">{{ project.name }}</strong>
          @if (project.description) {
            <p class="project-description">{{ project.description }}</p>
          }
          <span class="project-date">Created {{ project.createdAt | date: 'medium' }}</span>
        </a>
      }
    </div>
  }
</div>
